export default "__VITE_ASSET__CYwRhRAC__"